import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AgGridAngular } from "ag-grid-angular";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { RetailerService } from "src/app/features/retailers/retailer.service";
import { Module } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { Router } from "@angular/router";
import { InvoiceService } from "../invoice.service";
import { CurrencyPipe } from "@angular/common";
import { InvoiceDialogComponent } from "src/app/features-common/components/invoice-dialog/invoice-dialog.component";
import { MatDialog } from "@angular/material/dialog";

function actionCellRenderer(params) {
  let eGui = document.createElement("div");

  let editingCells = params.api.getEditingCells();
  // checks if the rowIndex matches in at least one of the editing cells
  let isCurrentRowEditing = editingCells.some((cell) => {
    return cell.rowIndex === params.node.rowIndex;
  });

  if (isCurrentRowEditing) {
    eGui.innerHTML = `
    <button  class="action-button update btn  btn-primary" type="button" data-action="update"> Update  </button>
    <button  class="action-button cancel btn  btn-warning" type="button" data-action="cancel" > Cancel </button>
    `;
  } else {
    eGui.innerHTML = `
    <button class=" action-button edit btn  btn-success" type="button" data-action="edit" > Edit  </button>
    <button class="action-button delete btn  btn-danger" type="button" data-action="delete" > Delete </button>
    `;
  }

  return eGui;
}
function numberParser(params) {
  return Number(params.newValue);
}
function floatParser(params) {
  return parseFloat(params.newValue);
}

@Component({
  selector: "app-report-newinvoice",
  templateUrl: "./new-invoice.component.html",
  styleUrls: ["./new-invoice.component.scss"],
  providers: [CurrencyPipe],
})
export class NewInvoiceComponent
  extends FeaturesBaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild("agGrid") agGrid: AgGridAngular;
  addInvoiceForm: FormGroup;
  // options: string[] = ['One', 'Two', 'Three'];
  filteredBusinessNameOptions: any[] = [];
  filteredRetailerAccNumOptions: any[] = [];
  lineItems: [];
  components;
  retailerDetails: any;
  selectedRetailerId: any;
  selectedOption: any;
  invoiceNumber: number;
  private gridApi;
  private gridColumnApi;
  public modules: Module[] = [ClientSideRowModelModule];
  columnDefs;
  defaultColDef;
  invoiceTotal: any = 0;
  invoiceId: any;
  invoiceDetails: any;
  newDate: Date = new Date();
  dueMinDate: Date = new Date();
  gridRowCount: number;
  disableSubmit: boolean = true;
  statusBar: any;
  itemsCodeData: any = [];

  constructor(
    private fb: FormBuilder,
    private retailerService: RetailerService,
    private invoiceService: InvoiceService,
    private router: Router,
    private currencyPipe: CurrencyPipe,
    private dialog: MatDialog
  ) {
    super();
    this.invoiceService.getitemcodes().subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.itemsCodeData = res["data"];
       
        this.columnDefs = [
          { field: "invoicRechargeId", headerName: "", width: 0, hide: true },
          {
            field: "itemCode",
            headerName: "Item Code",
            width: 140,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
              values: this.itemsCodeData,
            },
          },

          { field: "description", headerName: "Description", width: 180 },
          {
            field: "quantity",
            headerName: "Qty",
            valueParser: numberParser,
            width: 100,
            // type: "valueColumn",
          },
          /*{
            field: "price",
            headerName: "Price",
            width: 100,
            type: "valueColumn",
            valueParser: floatParser,
            cellRenderer: (data) => {
              return this.currencyPipe.transform(data.value);
            },
          },*/
          {
            field: "total",
            headerName: "Total",
            //valueGetter: 'getValue("quantity") * getValue("price")',
            width: 140,
            cellRenderer: (data) => {
              return this.currencyPipe.transform(data.value);
            },
          },
          {
            headerName: "Action",
            minWidth: 150,
            cellRenderer: actionCellRenderer,
            editable: false,
            colId: "action",
          },
        ];
      }
    });

    // Generate new invoice number
    this.invoiceService
      .generateNewInvoiceNumber()
      .subscribe(
        (res) =>
          (this.invoiceNumber = res["httpcode"] == 200 ? res["data"] : null)
      );
  }

  ngOnInit(): void {
    super.ngOnInit();
    // get all business name details
    this.retailerService.getRetailerBusinessNames().subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.retailerDetails = res["data"];
        this.filteredBusinessNameOptions = this.retailerDetails;
        this.filteredRetailerAccNumOptions = this.retailerDetails;
      }
    });
    this.setFormElements();
    this.onAutoSelectChanges();

    this.defaultColDef = {
      editable: true,
    };
    this.lineItems = [];
    this.addInvoiceForm.valueChanges.subscribe(() => {
      this.disableSubmit =
        this.addInvoiceForm.valid && this.invoiceTotal > 0 ? false : true;
    });
  }

  onAutoSelectChanges() {
    this.addInvoiceForm.get("businessName").valueChanges.subscribe((res) => {
      let businessName: string;
      businessName = res.businessName ? res.businessName : res;
      this.filteredBusinessNameOptions = this.retailerDetails;
      this.filteredBusinessNameOptions = res
        ? this._filterBusinessNames(businessName)
        : this.retailerDetails.slice();
    });
    this.addInvoiceForm.get("accountNo").valueChanges.subscribe((res) => {
      let accountNo: string;
      accountNo = res.retailerAccountNumber ? res.retailerAccountNumber : res;
      this.filteredRetailerAccNumOptions = this.retailerDetails;
      this.filteredRetailerAccNumOptions = res
        ? this._filterRetailerAccNum(accountNo)
        : this.retailerDetails.slice();
    });
  }

  private _filterBusinessNames(businessName: any): any {
    const filterValue = businessName.replace(/\s/g, "").toLowerCase();
    return this.retailerDetails.filter((option) =>
      option && option.businessName
        ? option?.businessName
            .toLowerCase()
            .replace(/\s/g, "")
            .indexOf(filterValue) === 0
        : false
    );
  }

  getOptionBusinessName(option) {
    return option && option ? option.businessName : "";
  }

  selectedBusinessNameDetails(e) {
    this.selectedOption = e.option.value;
    if (this.selectedOption && this.selectedOption) {
      this.addInvoiceForm.patchValue({
        accountNo: this.selectedOption,
        businessName: this.selectedOption,
        businessAddress1: this.selectedOption.address,
        retailerEmail: this.selectedOption.email,
      });
      this.selectedRetailerId = this.selectedOption.retailerId;
      return;
    }
  }

  private _filterRetailerAccNum(accountNo: string): any[] {
    const filterValue =
      accountNo && accountNo ? accountNo.replace(/\s/g, "").toLowerCase() : "";
    return this.retailerDetails.filter((option) =>
      option && option.retailerAccountNumber
        ? option?.retailerAccountNumber
            .toLowerCase()
            .replace(/\s/g, "")
            .indexOf(filterValue) === 0
        : false
    );
  }

  getOptionRetailerAccNum(option) {
    return option && option ? option.retailerAccountNumber : "";
  }

  selectedRetailerAccNum(e) {
   
    this.selectedOption = e.option.value;
    if (this.selectedOption && this.selectedOption) {
      this.addInvoiceForm.patchValue({
        accountNo: this.selectedOption,
        businessName: this.selectedOption,
        businessAddress1: this.selectedOption.address,
        retailerEmail: this.selectedOption.email,
      });
      this.selectedRetailerId = this.selectedOption.retailerId;
    }
  }

  setFormElements() {
    this.addInvoiceForm = new FormGroup({
      accountNo: new FormControl(""),
      retailerEmail: new FormControl(""),
      businessName: new FormControl(""),
      businessAddress1: new FormControl(""),
      issuedDate: new FormControl(new Date()),
      dueDate: new FormControl(""),
      comments: new FormControl(""),
    });
  }

  get f() {
    return this.addInvoiceForm.controls;
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onSubmit() {}

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onCellClicked(params) {
    // Handle click event for action cells
    if (
      params.column.colId === "action" &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === "edit") {
        params.api.startEditingCell({
          rowIndex: params.node.rowIndex,
          // gets the first columnKey
          colKey: params.columnApi.getDisplayedCenterColumns()[0].colId,
        });
      }

      if (action === "delete") {
        params.api.applyTransaction({
          remove: [params.node.data],
        });

        this.disableSubmit =
          this.gridApi.getDisplayedRowCount() === 0 ? true : false;

        this.invoiceTotal =
          this.gridApi.getDisplayedRowCount() === 0
            ? this.gridApi.getDisplayedRowCount()
            : this.invoiceTotal;
      }

      if (action === "update") {
        params.api.stopEditing(false);
        this.gridApi.forEachNode((node) => {
         
          this.itemsCodeData = this.itemsCodeData.filter(
            (x) => x !== node.data.itemCode
          );
         
        });
      }
      if (action === "cancel") {
        params.api.stopEditing(true);
      }
    }
    this.getGridDataValues();
  }

  getGridDataValues() {
    // get all grid rows data
    let items: Array<any> = [];
    this.gridApi.forEachNode((node) => {
      items.push(node.data);
     
     
      this.invoiceTotal = 0;
      items.forEach((item) => {
        // let _total = item.toal * item.price;
        this.invoiceTotal += Number(item.total);
        this.disableSubmit =
          this.invoiceTotal > 0 && this.addInvoiceForm.valid ? false : true;
       
       
        if (item.itemCode != "") {
         
         
        }
      });
    });
  }

  onRowEditingStarted(params) {
    params.api.refreshCells({
      columns: ["action"],
      rowNodes: [params.node],
      force: true,
    });
  }
  onRowEditingStopped(params) {
    params.api.refreshCells({
      columns: ["action"],
      rowNodes: [params.node],
      force: true,
    });
    if (!(this.invoiceTotal > 0)) {
      this.toastrService.warning(
        "Please check the line item values entered.",
        "Invalid line items"
      );
    }
  }

  addRow() {
    this.gridApi.updateRowData({
      add: [
        {
          invoicRechargeId: null,
          itemCode: "",
          description: "",
          quantity: 1,
          total: 0,
        },
      ],
    });
    this.disableSubmit =
      this.invoiceTotal > 0 && this.addInvoiceForm.valid ? false : true;
  }

  onSaveInvoice() {
    if (this.addInvoiceForm.invalid) {
      return;
    }
    this.invoiceService
      .createNewInvoioce(this.setFormData())
      .subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.toastrService.success(
            `Invoice #${this.invoiceNumber} created successfully`,
            "Success",
            { timeOut: 2000 }
          );

          this.invoiceId = res["data"].invoiceId;

          this.getInvoicePreview(this.invoiceId);
        }
      });
  }
  // Preview invoice after saving
  getInvoicePreview(invoiceId) {
    this.invoiceService.getInvoicePdf(invoiceId).subscribe((res) => {
      let data: any = res;
      var file = new Blob([data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(file);
      // set dialog with url for preview
      const dialogRef = this.dialog.open(InvoiceDialogComponent, {
        panelClass: "preview-panel",
        data: {
          fileURL: fileURL,
        },
      });

      dialogRef.afterClosed().subscribe(() => {
        this.router.navigate([
          `features/reports/invoices/email-preview/${this.invoiceId}`,
        ]);
      });
    });
  }

  // Preview invoice before saving
  previewBeforeSave() {
    if (this.addInvoiceForm.invalid) {
      return;
    }
    this.invoiceService
      .previewBeforeSave(this.setFormData())
      .subscribe((res) => {
        let data: any = res;
        var file = new Blob([data], { type: "application/pdf" });
        // set preview url
        var fileURL = URL.createObjectURL(file);
        const dialogRef = this.dialog.open(InvoiceDialogComponent, {
          panelClass: "preview-panel",
          data: {
            fileURL: fileURL,
          },
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
           
          }
        });
      });
  }

  setFormData() {
    let items: Array<any> = [];
    this.gridApi.forEachNode((node) => {
      items.push(node.data);
     
      items.forEach((item) => {
        //item["total"] = item.quantity * item.price;
        //;
      });
    });
   
   
   
    let invcStrtDt = this.addInvoiceForm.get("issuedDate").value;
    let invcDueDt = this.addInvoiceForm.get("dueDate").value;
    let formData = {
      invoice: {
        invoiceAmount: this.invoiceTotal,
        invoiceComments: this.addInvoiceForm.get("comments").value,
        invoiceDate: invcStrtDt,
        paymentDueDate: invcDueDt,
        invoiceNumber: this.invoiceNumber,
      },
      invoiceLineItems: items,
      retailerId: this.selectedRetailerId,
    };
    // formData['invoiceLineItems'] = items;
   
    return formData;
  }
}
